import type { Customer } from '@features/customers/types/customers.types';

export interface CustomerContactNumber {
    readonly label: string;
    readonly value: string;
}

/** `mobile_phone` is the only number collected now; a customer created before it was mandatory
 *  may carry only the retained `phone`, labelled as such. */
export const customerContactNumber = (
    customer: Pick<Customer, 'mobile_phone' | 'phone'> | null | undefined,
): CustomerContactNumber => {
    const mobile = customer?.mobile_phone?.trim();
    if (mobile) {
        return { label: 'Mobile', value: mobile };
    }

    const phone = customer?.phone?.trim();
    if (phone) {
        return { label: 'Phone', value: phone };
    }

    return { label: 'Mobile', value: 'Not provided' };
};
